import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import StarIcon from '@material-ui/icons/Star';
import Link from '../Link';
import s from './MobileMenu.css';

/**
 * Бургер для мобильной шапки: все разделы сайта и кнопка PRO.
 * «My themes» здесь нет — он в меню профиля.
 * @returns {*}
 * @constructor
 */
export default function MobileMenu({ links }) {
	useStyles(s);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const close = () => setAnchorEl(null);

	return (
		<>
			<IconButton
				aria-label="Menu"
				aria-controls="mobile-menu"
				aria-haspopup="true"
				onClick={e => setAnchorEl(e.currentTarget)}
			>
				<MenuIcon />
			</IconButton>

			<Menu
				id="mobile-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={close}
			>
				{links.map(link => (
					<Link
						key={link.href}
						to={link.href}
						className={s.menuLink}
						onClick={close}
					>
						<MenuItem>{link.title}</MenuItem>
					</Link>
				))}
				<li className={s.pro}>
					<Link to="/pro" className={s.menuLink} onClick={close}>
						<Button color="secondary" variant="contained" fullWidth>
							<StarIcon style={{ fontSize: 16 }} />
							&nbsp;PRO version
						</Button>
					</Link>
				</li>
			</Menu>
		</>
	);
}

MobileMenu.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			href: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
		}),
	).isRequired,
};
